import faker from 'faker';

import {
  IContractAttachment,
  IContractAttachmentData
} from '../contract.types';
import { ContractAttachment } from '../contract';
import { createRange } from '@/utils/helpers';

export function createRandomContractAttachment(): IContractAttachmentData {
  return {
    id: faker.datatype.number(),
    file: faker.image.imageUrl()
  };
}

export const mockContractAttachmentsData: IContractAttachmentData[] = createRange(
  6
).map(() => createRandomContractAttachment());

export const mockContractAttachments = (
  data: IContractAttachmentData[] = mockContractAttachmentsData
): IContractAttachment[] => data.map(item => new ContractAttachment(item));
